const content = require("./questionnaireV2Content.json");
function visibleQuestions(questions, answers = {}) {
  const result = [];
  for (let i = 0; i < questions.length; i++) {
    const q = questions[i];
    const ratingNumber = q.id.startsWith("v2_q")
      ? Number(q.id.substring(4))
      : null;
    const hiddenPainRating =
      q.type === "RATING" &&
      ratingNumber >= 24 &&
      ratingNumber <= 48 &&
      ratingNumber % 3 === 0 &&
      answers[`v2_q${ratingNumber - 1}`] === "no";
    if (!q.hidden && !hiddenPainRating) result.push(q);
    const rule = q.skipLogic;
    const answer = answers[q.id];
    if (!rule || answer === undefined || answer === null || answer === "")
      continue;
    const value = String(answer).split("|")[0];
    const skip =
      rule.condition === "EQUALS"
        ? value === rule.conditionValue
        : value !== rule.conditionValue;
    if (skip) {
      const next = questions.findIndex((x) => x.id === rule.targetQuestionId);
      if (next > i) i = next - 1;
    }
  }
  return result;
}
function questionError(q, answer) {
  if (
    answer === undefined ||
    answer === null ||
    answer === "" ||
    (Array.isArray(answer) && !answer.length)
  )
    return q.required ? "请填写此题" : null;
  const checkOption = (raw) => {
    if (typeof raw !== "string") return "请选择有效选项";
    const [value, ...parts] = raw.split("|");
    const opt = (q.options || []).find((x) => x.value === value);
    if (!opt) return "请选择有效选项";
    const custom = parts.join("|").trim();
    if (opt.allowCustomInput && !custom) return "请填写其他内容";
    if (!opt.allowCustomInput && parts.length) return "此选项不支持补充内容";
    if (q.id === "v2_q17" && value === "current" && !/^\d+$/.test(custom))
      return "吸烟支数请填写非负整数";
    return null;
  };
  if (q.type === "SINGLE_CHOICE") return checkOption(answer);
  if (q.type === "MULTIPLE_CHOICE") {
    if (!Array.isArray(answer)) return "请选择有效选项";
    const keys = answer.map((x) => String(x).split("|")[0]);
    if (new Set(keys).size !== keys.length) return "不能重复选择";
    if (keys.includes("none") && keys.length > 1)
      return "无不能与其他选项同时选择";
    return answer.map(checkOption).find(Boolean) || null;
  }
  if (q.type === "MATRIX") {
    if (typeof answer !== "object" || Array.isArray(answer))
      return "请完成每一行";
    const config = q.matrixConfig;
    if (Object.keys(answer).some((id) => !config.rows.some((r) => r.id === id)))
      return "存在无效矩阵行";
    return config.rows.every((r) => config.columns.includes(answer[r.id]))
      ? null
      : "请为每一行选择有效选项";
  }
  if (q.type === "NUMBER" || q.type === "RATING") {
    if (q.title.includes("小时") && q.title.includes("分钟")) {
      const parts = String(answer).match(/^(\d{1,2}):(\d{1,2})$/);
      return parts &&
        +parts[1] <= 24 &&
        +parts[2] <= 59 &&
        !(+parts[1] === 24 && +parts[2])
        ? null
        : "请填写有效小时和分钟";
    }
    if (
      (typeof answer !== "number" && typeof answer !== "string") ||
      String(answer).trim() === "" ||
      !Number.isFinite(Number(answer))
    )
      return "请填写有效数字";
    const n = Number(answer),
      config = q.ratingConfig || q.numberConfig || {};
    if (
      (config.min != null && n < config.min) ||
      (config.max != null && n > config.max) ||
      (q.type === "RATING" && !Number.isInteger(n))
    )
      return "数字超出允许范围";
  }
  return null;
}
function normalizeMultiple(next, changed, previous = []) {
  const items = next.map((value) => {
    const key = value.split("|")[0];
    return value.includes("|")
      ? value
      : previous.find((x) => x.split("|")[0] === key) || value;
  });
  if (changed === "none" && items.includes("none")) return ["none"];
  return items.length > 1 ? items.filter((x) => x !== "none") : items;
}
function submissionAnswers(questions, answers) {
  return Object.fromEntries(
    visibleQuestions(questions, answers)
      .filter((q) => answers[q.id] != null)
      .map((q) => [q.id, answers[q.id]])
  );
}
function draftKey(examId, studentId, revision) {
  return `questionnaire_V2_${examId}_${studentId}_${revision}`;
}
module.exports = {
  ...content,
  visibleQuestions,
  questionError,
  normalizeMultiple,
  submissionAnswers,
  draftKey,
};
